import React, { useRef, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { api, errMsg } from '../lib/api';
import { toast } from 'sonner';

export const CustomerRenameDialog = ({ customer, onClose, onSaved }) => {
  const [name, setName] = useState(customer.name);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const submit = async event => {
    event.preventDefault();
    if (inFlight.current || name.trim().length < 2) return;
    inFlight.current = true; setBusy(true); setError('');
    try {
      await api.patch(`/customers/${encodeURIComponent(customer.accountNo)}/name`, { name: name.trim() });
      toast.success('Customer name updated'); onSaved();
    } catch (failure) { setError(errMsg(failure)); }
    finally { inFlight.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent data-testid="customer-rename-dialog" className="w-[calc(100%-2rem)] max-w-md max-h-[90vh] overflow-y-auto">
      <DialogHeader><DialogTitle data-testid="customer-rename-title">Rename customer</DialogTitle><DialogDescription data-testid="customer-rename-account">{customer.accountNo}</DialogDescription></DialogHeader>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-2"><Label htmlFor="customer-rename-name">Full name</Label><Input id="customer-rename-name" data-testid="customer-rename-input" value={name} onChange={event => setName(event.target.value)} minLength={2} maxLength={150} required disabled={busy} autoComplete="off" /></div>
        {error && <p role="alert" data-testid="customer-rename-error" className="text-sm text-rose-700">{error}</p>}
        <DialogFooter className="gap-2"><Button data-testid="customer-rename-cancel" type="button" variant="outline" disabled={busy} onClick={onClose}>Cancel</Button><Button data-testid="customer-rename-save" type="submit" disabled={busy || name.trim().length < 2 || name.trim() === customer.name}>{busy ? 'Saving…' : 'Save name'}</Button></DialogFooter>
      </form>
    </DialogContent>
  </Dialog>;
};